import { render, staticRenderFns } from "./UserPersona.vue?vue&type=template&id=4e4da973&"
import script from "./UserPersona.vue?vue&type=script&lang=js&"
export * from "./UserPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports